module.exports = __webpack_public_path__ + "static/media/periodic-table-stout.1e9fc4df.png";